<template>
  
  <div id="udhr_instructions_wrapper" class="position-relative">
      <div id="un_texture" class="d-none d-lg-block"></div>
      <div id="side_texture" class="min-vh-100 d-none d-lg-block">
          <div class="bg" ></div>
      </div>
      <div class="container min-vh-100 d-flex align-items-center" >
          <div v-if="items" class="row justify-content-center justify-content-lg-end">
              <div class="col-8 col-sm-7 col-lg-4">
                    <img class="img-fluid declaration-img" v-if="instructionItem.value.image" v-lazy="instructionItem.value.image.url_resized" :alt="$t(iKey('udhr_section', instructionItem, 'image_desc' ))" >      
              </div>
              <div class="col-lg-6">
                    <h2 class="h3 mb-4 mt-5 mt-lg-0">{{ $t(iKey('udhr_section', instructionItem, 'headline' )) }}</h2>
                    <div class="explainer2" v-html="$t(iKey('udhr_section', instructionItem, 'description' ))"></div>
              </div>
          </div>
      </div>

       <CtaCircle
            aria-hidden="true"
            class="cta-circle"
            :trigger="'#udhr_instructions_wrapper'" 
            :label="$t($parent.iKey('udhr_section', 'udhr_intro', 'cta'))"
            :color="'019c95'"
             @clicked="scrollDown('#cs_1_pane_1')">
        </CtaCircle>
    
  </div>
  
</template>
<script>
import { TweenLite } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import CtaCircle from '@/components/ui/CtaCircle';
ScrollToPlugin; // needed so ScrollToPlugin gets regsitered w webpack.

export default {
  name: 'UdhrInstructions',
  components: {
      CtaCircle
  },
  computed: {
      instructionItem(){
          if(this.items[1]){
              return this.items[1]
          } else {
              return undefined
          }
      }
  },
  methods: {
      scrollDown(){
            TweenLite.to(window, 1, {scrollTo: '#udhr'})
        },
  },
  props: [
    'items',
  ]
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#udhr_instructions_wrapper {
    background-image: url(../../assets/images/manila-bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    color: white;
    z-index: 1;
}

#un_texture {
    position: absolute;
    left: 0;
    top: 10%;
    background-repeat: no-repeat;
    background-size: contain;
    width: 40vw;
    height: 40vh;
    background-image: url(../../assets/images/un-stamp.png);
    background-blend-mode: multiply;
}

#side_texture {
    position: absolute;
    left: 0;
    top: -100px;
}
#side_texture .bg {
    background-repeat: repeat-y;
    background-size: contain;
    width: 150px;
    height: calc(100vh + 100px);
    background-image: url(../../assets/images/udhr-text-texture.png);
}

.cta-circle {
    position: absolute;
    bottom: -50px;
    left: 100px;
}

</style>
